module.exports = __webpack_public_path__ + "img/success_check_pic.32a1d8a2.png";